!function(root, factory){

    factory(root, root.app);

}(this, function(root, app){

    //Some math functions to make the parallaxing of down-page elements less of a headache

    //Normalize a value between interval
    //E.g. norm(5, 0, 10) -> 0.5
    function norm(val, min, max) {
        return (val - min) / (max - min);
    }

    //Linear interpolation within interval
    //E.g. lerp(0.5, 0, 10) -> 5.0
    function lerp(norm, min, max) {
        return (max - min) * norm + min;
    }

    //Map a value's relative position in one range into another range
    //Basically, if val is 16 and the first range is 10-30 and the second range
    //is 0-10, the resulting value would be 3.  You take the relative position
    //of the value within the
    //first range and use it to calculate the output in the second range.
    function mapLerp(val, sourceMin, sourceMax, destMin, destMax) {
        var n = norm(val, sourceMin, sourceMax);
        return lerp(n, destMin, destMax);
    }

    //Gets two ranges (This is used for down-page parallaxing)
    //  - Viewtop when the element first becomes visible as you scroll TO when the element leaves the view
    //  - 0 to the height of the element
    //This is needed because we don't know how far down the page the section with parallax
    //will be or how tall said section will be. We can't effectively base the parallax
    //directly off view height
    //Instead we interpolate over the entire time the section is is in the viewport.  This
    //function gets the upper and lower bounds of an element required to call the
    //mapLerp() function
    function getRelativeValuesForAnElement($element) {
        var elemHeight = $element.outerHeight();
        var elemTop = $element.offset().top;
        var elemBottom = elemTop + elemHeight;
        var sourceMin = elemTop - overwatch.util.height();
        var sourceMax = elemBottom;
        var destMin = 0;
        var destMax = elemHeight;
        return {
            sourceMin: sourceMin,
            sourceMax: sourceMax,
            destMin: destMin,
            destMax: destMax
        };
    }

    app.extend({ mathUtil: {
        norm: norm,
        lerp: lerp,
        mapLerp: mapLerp,
        getRelativeValuesForAnElement: getRelativeValuesForAnElement,
    }});

    return app.mathUtil;

});
